module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/step1.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/step1.png
// module id = 486
// module chunks = 0